import React, { FC } from 'react'

import styled from 'styled-components'

import { ArtistBalanceItemProps } from '.'

type ArtistBalanceItemTransactionTypeProps = Pick<
  ArtistBalanceItemProps,
  'text' | 'icon' | 'bold' | 'subText'
>
const Container = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  max-width: 480px;
  flex: 1 0 0;
`
const IconContainer = styled.div`
  display: flex;
  padding: 4px 0px;
  align-items: center;
  gap: 10px;

  svg {
    path {
      fill: ${({ theme }) => theme.color.darkGrey};
    }
  }
`

const Text = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
`

const SubText = styled(Text)`
  font-size: 14px;
  color: ${({ theme }) => theme.color.slateGrey};
`

export const ArtistBalanceItemTransactionType: FC<
  ArtistBalanceItemTransactionTypeProps
> = (props) => {
  const { text, icon: Icon, bold, subText } = props
  return (
    <Container>
      <IconContainer>
        <Icon width={16} height={16} />
      </IconContainer>
      <div>
        <Text style={{ fontWeight: bold ? '600' : 'normal' }}>{text}</Text>
        {subText && <SubText>{subText}</SubText>}
      </div>
    </Container>
  )
}
